import { Amplify } from 'aws-amplify'

export const configureAmplify = async () => {
  const host = window.location.host

  const subDomains = [
    { subDomain: 'qa2-diagnostics', domain: 'tr-dev.net' },
    { subDomain: 'qa-diagnostics', domain: 'tr-qa.net' },
    { subDomain: 'stage1-diagnostics', domain: 'tr-staging.net' },
    { subDomain: 'diagnostics', domain: 'tranehome.net' },
    { subDomain: 'localhost:8090', domain: 'tr-dev.net' }
  ]
  const subDomain = host.split('.')[0]
  const traneDomain = host.split('.')[1]
  const amplifyDomain = traneDomain === 'tranetechdev' ? 'tr-dev.net' : subDomains.find(s => s.subDomain === subDomain)?.domain

  return fetch(`https://metadata.${amplifyDomain}/amplify-config-trane.json?1`)
    .then(async (response) => await response.json())
    .then((config) => {
      Amplify.configure({
        ...config,
        API: {
          ...config.API,
          REST: {
            ...config.API?.REST,
            deviceLookupApi: {
              name: 'deviceLookupApi',
              endpoint: `https://device-lookup-api.${amplifyDomain}`
            },
            dwaApi: {
              name: 'dwaApi',
              endpoint: `https://dwa-api-v2.${amplifyDomain}`
            },
            hehmApi: {
              name: 'HomeHealthAPI',
              endpoint: `https://home-health-api.${amplifyDomain}`
            },
            technicianBotApi: {
              name: 'technicianbotapi',
              endpoint: `https://technician-bot-api.${amplifyDomain}`
            }
          }
        }
      })
    })
}
